<template>
  <div class="mian">
    <div class="contact">
      <div>
        <img src="../assets/icon-call.png" alt="" />
        <p>0451-86422511</p>
        <p>010-62960249</p>
      </div>
      <span @click="$refs.trialModal.show()">预约试用</span>
    </div>
    <trialModal ref="trialModal"></trialModal>
  </div>
</template>

<script>
import trialModal from "./trialModal"
export default {
  name: "contact",
  components: { trialModal }
};
</script>

<style scoped>
.contact {
  height: 2rem;
  background: #0f70ff;
  padding-top: 0.4rem;
  margin-top: 0.6rem;
}

.contact div {
  display: flex;
  align-items: center;
  justify-content: center;
}

.contact div img {
  width: 0.26rem;
}

.contact div p {
  font-size: 0.32rem;
  color: #fff;
  font-weight: bold;
  margin-left: 0.3rem;
}

.contact span {
  text-align: center;
  font-size: 0.24rem;
  color: #1070ff;
  font-weight: bold;
  width: 4rem;
  line-height: 0.56rem;
  background: #fff;
  cursor: pointer;
  margin: 0.2rem auto 0;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/contact.vue